import classNames from "classnames";
import { SearchAutocomplete } from "./SearchAutocomplete";
import { Logger } from "~/utils/logger";
const logger = new Logger("search", "info");

export function Search(props: {
  responsive_sizing: string;
  constrain_menu_width: string;
  additional_menu_width: number;
  search_url: string;
  _z_index: number;
}) {
  const isResponsiveSizingEnabled = props.responsive_sizing === "yes";
  const isConstrainMenuWidthEnabled = props.constrain_menu_width === "yes";

  // normally the left/right gap is used to shrink the menu. in this case we want to
  // increase its width, so we use a negative number
  const additionalMenuWidth = props.additional_menu_width
    ? -props.additional_menu_width
    : 10;

  // if the _z_index Elementor property is set for this component, use it
  const zIndex = props._z_index ? props._z_index : 1000;

  logger.debug("props:", props);
  if (!props.search_url) {
    logger.warn("Search widget: search_url is not defined in props");
  }

  return (
    <div
      className={classNames(
        isResponsiveSizingEnabled
          ? "tw:w-[300px] tw:xl:w-[400px]"
          : "tw:w-full",
      )}
    >
      <SearchAutocomplete
        search_url={props.search_url}
        menuParentWidth={isConstrainMenuWidthEnabled}
        menuGapLeft={additionalMenuWidth}
        menuGapRight={additionalMenuWidth}
        zIndex={zIndex}
      />
    </div>
  );
}
